import React from "react";
import {SnackbarProvider, MaterialDesignContent} from "notistack";
import {styled} from "@mui/material/styles";
import {getTheme} from "../theme";

const StyledSnackBarOverrides = styled(MaterialDesignContent)(({theme}) => ({
    "&.notistack-MuiContent-success": {
        backgroundColor: theme.palette.success.main,
    },
    "&.notistack-MuiContent-error": {
        backgroundColor: theme.palette.error.main,
    },
    "&.notistack-MuiContent-info": {
        backgroundColor: theme.palette.primary.main,
    },
    "&.notistack-MuiContent-warning": {
        backgroundColor: theme.palette.warning.main,
    },
}));

const CustomSnackbarProvider = ({children}) => {
    const currentTheme = getTheme();

    return (
        <SnackbarProvider
            style={{
                fontFamily: currentTheme.typography.fontFamily,
            }}
            maxSnack={10}
            autoHideDuration={10000}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            Components={{
                success: StyledSnackBarOverrides,
                error: StyledSnackBarOverrides,
                info: StyledSnackBarOverrides,
                warning: StyledSnackBarOverrides,
            }}
        >
            {children}
        </SnackbarProvider>
    );
};

export default CustomSnackbarProvider;